import { createOrbitalGradientController } from './orbital-gradient.component.js';

let footerGradientController = null;
let footerGradientRoot = null;
let footerGradientInit = null;
let shouldPlayFooterGradient = true;

window.footerGradientGSAPAnimation = async function () {
  const root = document.querySelector('.footer-bg');
  const main = document.querySelector('.main');

  if (!root || !main) return;
  if (
    root === footerGradientRoot &&
    (footerGradientController || footerGradientInit)
  ) {
    return;
  }

  footerGradientController?.destroy();
  footerGradientController = null;
  footerGradientRoot = root;

  footerGradientInit = createOrbitalGradientController(root, {
    maskSupported: true,
    orbitSet: { xPercent: 0, yPercent: -50 },
    selectors: {
      orbit: '.footer-bg__bg-decor-ellipses',
      first:
        '.footer-bg__bg-decor-ellipse-img-wr:nth-child(1) .footer-bg__bg-decor-ellipse-img',
      second:
        '.footer-bg__bg-decor-ellipse-img-wr:nth-child(2) .footer-bg__bg-decor-ellipse-img',
      images: '.footer-bg__bg-decor-ellipses img',
    },
  });
  const controller = await footerGradientInit;

  if (footerGradientRoot !== root) {
    controller?.destroy();
    return;
  }

  footerGradientController = controller;
  footerGradientInit = null;

  if (footerGradientController) {
    document.documentElement.classList.add('is-footer-orbital-gradient-ready');
    window.dispatchEvent(new CustomEvent('orbital-gradient:footer-ready'));
  }

  if (!footerGradientController || shouldPlayFooterGradient) return;
  footerGradientController.pause();
};

window.pauseFooterGradientAnimation = function pauseFooterGradientAnimation() {
  shouldPlayFooterGradient = false;
  footerGradientController?.pause();
};

window.resumeFooterGradientAnimation =
  function resumeFooterGradientAnimation() {
    shouldPlayFooterGradient = true;
    footerGradientController?.resume();
  };

footerGradientGSAPAnimation();

if (!document.querySelector('.bold-loader-new')) {
  pauseFooterGradientAnimation();
}
